// publicSuffixes.ts
// Generated from https://publicsuffix.org/list/public_suffix_list.dat

export const PUBLIC_SUFFIXES = new Set<string>([
    'com',
    'org',
    'net',
    'edu',
    'gov',
    'uk',
    'co.uk',
    'org.uk',
    'gov.uk',
    'ac.uk',
    'au',
    'com.au',
    'net.au',
    'org.au',
    'co.nz',
    'com.sg',
    'com.br',
    'jp',
    'co.jp',
    'ne.jp',
    'or.jp',
    'go.jp',
    'de',
    'fr',
    'us',
    'ca',
    'cn',
    'com.cn',
    'net.cn',
    'org.cn',
    'co.kr',
    'or.kr',
    'go.kr',
    'in',
    'co.in',
    'net.in',
    'org.in',
    'firm.in',
    'gen.in',
    'ind.in',
    // ... (additional suffixes)
  ]);
  